<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Rewards</h3>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Coming soon...</h4>
            </div>
            <div class="card-content">
              <div class="card-body">
                <p>For the items you purchase through your Golden Spoon App.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'rewards'
}
</script>
